export default __webpack_public_path__ + "static/media/mobscore_geocoordinates_template.96c9013e.csv";